const themeImages = document.querySelectorAll('[data-theme-image]');
const allowedThemes = new Set(['light', 'dark']);
const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

const activeTheme = () => {
  const theme = document.documentElement.dataset.theme;

  return allowedThemes.has(theme) ? theme : (mediaQuery.matches ? 'dark' : 'light');
};

const syncImage = (image) => {
  const theme = activeTheme();
  const nextSrc = theme === 'dark' ? image.dataset.darkSrc : image.dataset.lightSrc;

  image.dataset.currentTheme = theme;

  if (!nextSrc || image.getAttribute('src') === nextSrc) {
    return;
  }

  image.setAttribute('src', nextSrc);
};

const syncImages = () => {
  themeImages.forEach(syncImage);
};

if (themeImages.length > 0) {
  syncImages();

  const observer = new MutationObserver(syncImages);
  observer.observe(document.documentElement, {
    attributeFilter: ['data-theme'],
    attributes: true,
  });

  mediaQuery.addEventListener?.('change', syncImages);
}
